/**
 * @desc 保存
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(body: defs.esca.EApiRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/eApi/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
